module.exports = __webpack_public_path__ + "img/624.494e4322.png";